import { ReactNode, Suspense, lazy } from "react";
import { Navbar } from "./Navbar";
import { B2BCommissionPopupMount } from "./B2BCommissionPopupMount";
import { DeferUntilIdle } from "./DeferUntilIdle";

const LatestBlogGrid = lazy(() =>
  import("./LatestBlogGrid").then((m) => ({ default: m.LatestBlogGrid })),
);



// Defer below-the-fold chrome — these don't affect FCP and shouldn't block
// initial paint on mobile. Lazy-loaded with null fallback so layout stays
// visually identical until each component hydrates in. On mobile we
// additionally gate behind requestIdleCallback to cut main-thread work
// during the FCP/LCP window.
const Footer = lazy(() =>
  import("./Footer").then((m) => ({ default: m.Footer })),
);
const SignupPrompt = lazy(() =>
  import("./SignupPrompt").then((m) => ({ default: m.SignupPrompt })),
);
const WhatsAppFloatingButton = lazy(() =>
  import("./WhatsAppFloatingButton").then((m) => ({ default: m.WhatsAppFloatingButton })),
);

export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="site-shell min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-white p-3 rounded z-50"
      >
        Skip to content
      </a>
      <div className="site-bg-mesh pointer-events-none fixed inset-0 -z-10 gradient-mesh" />
      <div className="site-bg-hero pointer-events-none fixed inset-x-0 top-0 -z-10 h-[700px] gradient-hero opacity-80" />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="flex-1 outline-none">{children}</main>
      <B2BCommissionPopupMount />
      {/* Reserve space for the deferred cluster (LatestBlogGrid ~600px +
          Footer ~600px desktop / ~900px mobile + SignupPrompt). Under-
          reserving here was the dominant CLS source across routes because
          hydration inserted ~1200-1600px of content into a 520px slot. */}
      <div
        className="site-shell-deferred-slot"
        style={{
          contentVisibility: "auto",
          containIntrinsicSize: "1px 1600px",
        }}
      >
        <DeferUntilIdle timeout={2000}>
          <Suspense fallback={null}>
            <LatestBlogGrid />
            <Footer />
            <SignupPrompt />
            <WhatsAppFloatingButton />
          </Suspense>
        </DeferUntilIdle>
      </div>


    </div>
  );
}
